interface Props {
  isSorted: false | 'asc' | 'desc';
}

export default function SortIndicator({ isSorted }: Props) {
  if (!isSorted) return null;
  return (
    <span className="ml-1">
      {isSorted === 'asc' ? '↑' : '↓'}
    </span>
  );
}
